import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
	Button,
	Form,
	Input,
	Modal,
	Row,
	Select,
	Spin,
	Table,
	Tooltip,
} from "antd";
import moment from "moment";

import Swal from "sweetalert2";

import partnersApi from "../../apis/Partners.api";
import plutusApi from "../../apis/Plutus.api";
import LinkComponent from "../../components/layout/LinkComponent";
import UserManageNav from "../../components/userManageGroup/userManageNav";
import { setLoading } from "../../redux/store/common/commonDuck";

const UserMessage = () => {
	const dispatch = useDispatch();

	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [influencerList, setInfluencerList] = useState([]);
	const [smsSendShow, setSmsSendShow] = useState(false);
	const [smsCount, setSmsCount] = useState(0);
	const [smsList, setSmsList] = useState([]);
	const [smsMessage, setSmsMessage] = useState("");
	const [smsLink, setSmsLink] = useState(null);
	const [selectInfluencer, setSelectInfluencer] = useState({
		value: 0,
		label: "직접입력",
		influencer_id: "",
	});

	const [smsListEach, setSmsListEach] = useState({});
	const [smsListEachShow, setSmsListEachShow] = useState(false);

	const columns = [
		{
			title: "발송시간",
			dataIndex: "send_date",
			key: "send_date",
			ellipsis: true,
			width: "20%",
			render: (value) => {
				return <span>{moment(value).format("YYYY.MM.DD hh:mm:ss")}</span>;
			},
		},
		{
			title: "메세지 내용",
			dataIndex: "content",
			key: "content",
			ellipsis: true,
			width: "55%",
			render: (value) => {
				return <span>{value}</span>;
			},
		},
		{
			title: "발송건수",
			dataIndex: "totalCnt",
			key: "totalCnt",
			ellipsis: true,
			// width: "55%",
			render: (value) => {
				return <span>{value}</span>;
			},
		},
		{
			title: "카톡",
			dataIndex: "successCnt",
			key: "successCnt",
			ellipsis: true,
			// width: "55%",
			render: (value) => {
				return <span>{value}</span>;
			},
		},
		{
			title: () => {
				return (
					<Row justify="center" align={"middle"}>
						<p>문자</p>
						<Tooltip
							placement={"bottomRight"}
							trigger={`click`}
							title={"카톡 실패시 대체 발송"}
							overlayStyle={{ whiteSpace: "pre-wrap" }}
						>
							<img
								src={`/assets/images/report/notice.png`}
								alt={`세금 안내`}
								style={{
									height: "1.1em",
									width: "auto",
									cursor: "pointer",
									marginLeft: "3px",
								}}
							/>
						</Tooltip>
					</Row>
				);
			},
			dataIndex: "failCnt",
			key: "failCnt",
			ellipsis: true,
			// width: "55%",
			render: (value) => {
				return <span>{value}</span>;
			},
		},
	];

	useEffect(() => {
		if (user?.role === "super_admin") {
			getExpertList();
		}
		getSMSCount();
		getSMSSendList();
	}, [user]);

	const getExpertList = async () => {
		const res = await plutusApi.readLonglifeExpertList();
		if (res.code === 200) {
			let list = res.result?.expertList;
			if (list?.length) {
				setInfluencerList([
					{
						value: 0,
						label: "직접입력",
						influencer_id: "",
					},
					...list.map((item) => ({
						value: item.partners_id,
						label: item.name,
						influencer_id: item?.influencer_id,
					})),
				]);
			}
		}
	};

	/**
	 * sms 발송 가능 회원 수
	 * @returns {Promise<void>}
	 */
	const getSMSCount = async () => {
		let param = {
			// userId: user.id,
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
		};
		const res = await partnersApi.smsReadCount(param);
		if (res.code === 200) {
			setSmsCount(res.result ?? 0);
		}
	};

	/**
	 * sms 발송 리스트
	 * @returns {Promise<void>}
	 */
	const getSMSSendList = async () => {
		setIsLoading(true);
		let param = {
			// userId: user.id,
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
		};
		const res = await partnersApi.smsSendList(param);
		if (res.code === 200) {
			setSmsList(res.result);
		}
		setIsLoading(false);
	};

	/**
	 * sms 메시지 보내기
	 * @returns {Promise<void>}
	 */
	const sendMessage = async () => {
		let sendAvailable = false;
		if (user?.role === "super_admin" && !smsLink) {
			await Swal.fire({
				customClass: "alert-custom",
				text: "링크가 비어있어 당영몰 홈으로 이동됩니다.그래도 전송하시겠습니까?",
				confirmButtonText: "확인",
			}).then((res) => {
				if (res.isConfirmed) {
					sendAvailable = true;
				}
			});
		} else {
			sendAvailable = true;
		}
		if (sendAvailable) {
			setIsLoading(true);
			let param = {
				influencer_id:
					user?.role === "level_1" || user?.role === "super_admin"
						? user?.id
						: user?.partners_id,
				content: smsMessage,
			};
			if (user?.role === "super_admin") {
				param["link"] = smsLink;
			}
			const res = await partnersApi.postSmsSend(param);
			if (res.code === 200) {
				Swal.fire({
					customClass: "alert-custom",
					text: "전송이 완료되었습니다.",
					confirmButtonText: "확인",
				}).then(() => {
					setSmsSendShow(false);
					setSmsMessage("");
					setSelectInfluencer({
						value: 0,
						label: "직접입력",
						influencer_id: "",
					});
					setSmsLink(null);
				});
			}
			const timer = setTimeout(() => {
				getSMSCount();
				getSMSSendList();
				setIsLoading(false);
			}, 500);
			return () => clearTimeout(timer);
		}
	};

	/**
	 * sms 메세지 내용 확인하기
	 * @param record
	 */
	const clickRowMessageEach = (record) => {
		setSmsListEach(record);
		setSmsListEachShow(!smsListEachShow);
	};

	return (
		<div className="main-wrap">
			<div className="max-width-apply">
				<LinkComponent />

				<h1 className="main-title">회원 관리</h1>

				<UserManageNav />

				<div className={`main-body`}>
					<Row className={`user-manage-numbers`}>
						<p>sms 발송 가능 회원 수</p>
						<h3>{smsCount?.toLocaleString()}</h3>
					</Row>

					{/* SMS 발송 리스트 */}
					{isLoading ? (
						<Spin
							style={{ margin: "auto", width: "100%", paddingTop: "2em" }}
						/>
					) : (
						<div className={`main-body`}>
							<div
								style={{
									display: "flex",
									alignItems: "center",
									justifyContent: "space-between",
								}}
							>
								<h3 className={`body-title`}>
									SMS 발송 리스트
									<span
										style={{
											color: "#117ffa",
											fontWeight: "bold",
											marginLeft: "3px",
										}}
									>
										{smsList?.length}
									</span>
								</h3>
								<Button
									className={`sms-black-button`}
									loading={isLoading}
									onClick={() => setSmsSendShow(!smsSendShow)}
								>
									+ SMS 메세지 보내기
								</Button>
							</div>

							<Table
								dataSource={smsList}
								className="group-buying-table"
								rowKey={`send_date`}
								style={{ padding: "0.5em 0" }}
								columns={columns}
								pagination={false}
								onRow={(record) => {
									return {
										onClick: () => {
											clickRowMessageEach(record);
										},
									};
								}}
							/>
						</div>
					)}

					{/* sms 메세지 보내기 */}
					<Modal
						title="SMS 메세지 보내기"
						wrapClassName="sms-send-modal"
						open={smsSendShow}
						centered={true}
						onCancel={() => {
							setSmsSendShow(!smsSendShow);
							setSmsMessage("");
							setSelectInfluencer({
								value: 0,
								label: "직접입력",
								influencer_id: "",
							});
							setSmsLink(null);
						}}
						width="45%"
						footer={
							<Button
								className={
									isLoading || !smsMessage
										? "sms-modal-btn-disabled"
										: "sms-modal-btn"
								}
								onClick={sendMessage}
								disabled={isLoading || !smsMessage}
								loading={isLoading}
							>
								전송하기
							</Button>
						}
					>
						<Form labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
							<Form.Item label="발송건수" labelAlign="left" colon={false}>
								<Input type={`text`} placeholder={smsCount} disabled={true} />
							</Form.Item>
							<Form.Item label="메세지" labelAlign="left" colon={false}>
								<Input.TextArea
									type={`text`}
									placeholder={`메세지 내용을 입력해주세요`}
									required
									onChange={(e) => setSmsMessage(e.target.value)}
									value={smsMessage}
									showCount={true}
									maxLength={1000}
									style={{
										resize: "none",
									}}
								/>
							</Form.Item>
							<Form.Item
								label=" "
								labelAlign="left"
								colon={false}
								labelCol={{ span: 6 }}
								wrapperCol={{ span: 18 }}
								style={{ margin: 0 }}
							>
								<p style={{ margin: 0, fontSize: "0.9em", color: "#adb5bd" }}>
									*오전 8시부터 오후 8시까지 전송이 가능합니다.
								</p>
							</Form.Item>
							{user?.role === "super_admin" && (
								<>
									<Form.Item
										label="링크"
										labelAlign="left"
										colon={false}
										labelCol={{ span: 6 }}
										wrapperCol={{ span: 18 }}
										style={{ marginTop: "2rem", marginBottom: 0 }}
									>
										<Select
											options={influencerList}
											onChange={(value, option) => {
												setSelectInfluencer(option);
												if (option?.influencer_id) {
													setSmsLink(
														`https://www.dangyoung.com/together/@${option?.influencer_id}`
													);
												} else {
													setSmsLink(null);
												}
											}}
											value={selectInfluencer.label}
											style={{ marginBottom: "1rem", width: "20rem" }}
											disabled={isLoading}
										/>
									</Form.Item>
									<Form.Item
										label=" "
										labelAlign="left"
										colon={false}
										labelCol={{ span: 6 }}
										wrapperCol={{ span: 18 }}
										style={{ margin: 0 }}
									>
										<Input
											type={`text`}
											value={smsLink}
											placeholder={"https://로 시작하는 링크를 입력해주세요."}
											onChange={(e) =>
												setSmsLink(e.target.value?.replace(/(\s*)/g, ""))
											}
											disabled={selectInfluencer.influencer_id}
										/>
									</Form.Item>
									<Form.Item
										label=" "
										labelAlign="left"
										colon={false}
										labelCol={{ span: 6 }}
										wrapperCol={{ span: 18 }}
										style={{ margin: 0 }}
									>
										<p
											style={{ margin: 0, fontSize: "0.9em", color: "#adb5bd" }}
										>
											*미입력시 당영몰로 연결됩니다.
										</p>
									</Form.Item>
								</>
							)}
						</Form>
					</Modal>

					{/* sms 메세지 확인하기*/}
					<Modal
						title="SMS 메세지 발송내역 확인하기"
						wrapClassName="sms-send-modal"
						open={smsListEachShow}
						centered={true}
						onCancel={() => setSmsListEachShow(!smsListEachShow)}
						width="45%"
						footer={null}
					>
						<Form>
							<Row style={{ gap: "2em", marginBottom: "1.5em" }}>
								<Form.Item
									label="발송건수"
									labelAlign="left"
									style={{ margin: 0 }}
									// colon={false}
								>
									<p style={{ margin: 0 }}>{smsListEach.totalCnt}</p>
								</Form.Item>
								<Form.Item
									label="카톡"
									labelAlign="left"
									style={{ margin: 0 }}
									// colon={false}
								>
									<p style={{ margin: 0 }}>{smsListEach.successCnt}</p>
								</Form.Item>
								<Form.Item
									label="문자"
									labelAlign="left"
									style={{ margin: 0 }}
									// colon={false}
								>
									<p style={{ margin: 0 }}>{smsListEach.failCnt}</p>
								</Form.Item>
							</Row>
							<Form.Item
								label="메세지 내용"
								labelAlign="left"
								colon={false}
								labelCol={{ span: 6 }}
								wrapperCol={{ span: 18 }}
							>
								<Input.TextArea
									type={`text`}
									placeholder={smsListEach.content}
									required
									// onChange={(e) => setSmsMessage(e.target.value)}
									value={smsListEach.content}
									disabled={true}
									style={{
										resize: "none",
									}}
								/>
							</Form.Item>
						</Form>
					</Modal>
				</div>
			</div>
		</div>
	);
};
export default UserMessage;
